import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.primary};
  .anticon svg {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .userdata-page h1 {
    font-weight: 500;
    font-size: 18px;
    color: #1890ff;
    margin: 0 0 24px 24px;
  }

  .userdata-page ul {
    list-style: none;
    padding: 0;
  }

  .userdata-page ul li {
    font-size: 14px;
    color: #595959;
  }

  .userdata-page ul li + li {
    margin-top: 24px;
  }

  .userdata-page .avatar {
    padding: 8px 44px;
  }

  .userdata-page .avatar strong {
    display: block;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .userdata-page .avatar button {
    display: block;
    width: 100%;
  }
  .ant-tabs-nav-wrap {
    border-right: 1px solid #e8e8e8;
  }
  .avatar {
    display: grid;
    gap: 10px;
    margin-left: 2rem;
    justify-items: center;

    .ant-avatar {
      margin-bottom: 1rem;
    }

    button {
      width: 160px;
      height: 32px;
      border-radius: 2px;
      padding: 5px 16px 5px 16px;
      font-weight: normal;
      font-size: 13px;
      line-height: 22px;
    }
  }
`;
